import React, { useState, useEffect } from "react";
import "./HomeScreen.css";
import TruckImages from "./TruckImages";
import { Link } from "react-router-dom";
import ExpandableImage from "./Sticker";
import { db } from "./firebase";
import { collection, onSnapshot } from "firebase/firestore";

const industries = [
  "Retail",
  "FMCG",
  "Construction",
  "Agriculture",
  "Moving & Relocation",
  "E-commerce",
];

export default function HomeScreen() {
  const [trucks, setTrucks] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "pricingmodel"), (snap) => {
      setTrucks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, []);

  return (
    <div className="home">

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-eyebrow">Africa's On-Demand Logistics Platform</span>

          <h1>Transport That's Simple,<br />Swift &amp; Reliable.</h1>

          <p>
            Move goods, homes, or bulk cargo anywhere in Africa with verified trucks —
            every payment secured by escrow.
          </p>

          <div className="hero-buttons">
            <a
              href="https://play.google.com/store/apps/details?id=com.MrTruck"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="primary-btn">Book a Truck ↗</button>
            </a>

            <Link to="/corporate">
              <button className="secondary-btn">Get Corporate Quote</button>
            </Link>
          </div>

          <div className="trust-badges">
            <span><i className="fa-solid fa-check" /> Transparent Pricing</span>
            <span><i className="fa-solid fa-check" /> Verified Drivers</span>
            <span><i className="fa-solid fa-check" /> Real-Time Tracking</span>
            <span><i className="fa-solid fa-check" /> eTIMS Receipts</span>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section steps-section">
        <span className="section-label">How It Works</span>
        <h2 className="section-title">Three Simple Steps</h2>
        <p className="section-subtitle">
          Book a truck, confirm your load, and track your delivery — all from your phone.
        </p>

        <div className="steps">
          <div className="step">
            <div className="icon">1</div>
            <h4>Book a Truck</h4>
            <p>Choose your truck size and schedule your pickup in minutes.</p>
          </div>

          <div className="step">
            <div className="icon">2</div>
            <h4>Seal the Order</h4>
            <p>Confirm once goods are loaded — payment is held securely in escrow.</p>
          </div>

          <div className="step">
            <div className="icon">3</div>
            <h4>Mark Complete</h4>
            <p>Track your delivery in real time and release payment on arrival.</p>
          </div>
        </div>
      </section>

      {/* TRUCK CATEGORIES */}
      <section className="section truck-section">
        <span className="section-label">Our Fleet</span>
        <h2>Truck Categories</h2>
        <p className="section-subtitle">
          From compact pickups to heavy 20-ton trucks — the right vehicle for every load.
        </p>

        <div className="truck-grid">
          {trucks.map((truck) => (
            <div className="truck-card" key={truck.id}>
              {truck.svg && (
                <div
                  className="truck-card-svg"
                  dangerouslySetInnerHTML={{ __html: truck.svg }}
                />
              )}
              <h3>{truck.type}</h3>
              <span className="truck-capacity">Up to {truck.capacity} Tonnes</span>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section industries-section">
        <span className="section-label">Industries</span>
        <h2>Industries We Serve</h2>
        <p className="section-subtitle">
          Trusted by businesses across a wide range of sectors throughout Africa.
        </p>

        <div className="industry-badges">
          {industries.map((industry, index) => (
            <span key={index} className="industry-badge">
              {industry}
            </span>
          ))}
        </div>
      </section>

      {/* TRUCK PHOTO SLIDER */}
      <section className="section slider-section">
        <TruckImages />
      </section>

      {/* TESTIMONIAL */}
      <section className="section testimonial">
        <span className="section-label">Client Stories</span>
        <h2>What Our Clients Say</h2>

        <div className="testimonial-inner">
          <div className="testimonial-card">
            <span className="quote-mark">"</span>
            <p>
              Mr Truck helped us move construction materials across Nairobi
              seamlessly. Reliable, transparent, and thoroughly professional.
            </p>
            <strong>— Construction Manager</strong>
            <p className="testimonial-date">January 20<sup>th</sup>, 2026</p>
          </div>

          <div className="testimonial-feedback">
            Share your experience at{" "}
            <a href="mailto:feedback@mrtruck.co.ke">feedback@mrtruck.co.ke</a>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>Need reliable transport today?</h2>
        <p>Join thousands of businesses and individuals who trust Mr Truck.</p>
        <a
          href="https://play.google.com/store/apps/details?id=com.MrTruck"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="primary-btn large-btn">Book a Truck Now ↗</button>
        </a>
      </section>

      {/* STICKY BUTTON (Mobile) */}
      <ExpandableImage />

    </div>
  );
}
